export const UPCOMING_NFO = "UPCOMING_NFO";
export const UPCOMING_NFO_ADD_MSG = "UPCOMING_NFO_ADD_MSG";
export const UPCOMING_NFO_CLEAR_MSG = "UPCOMING_NFO_CLEAR_MSG";
export const UPCOMING_NFO_ERROR = "UPCOMING_NFO_ERROR";
export const UPCOMING_NFO_HIDE_ERROR = "UPCOMING_NFO_HIDE_ERROR";
export const UPCOMING_NFO_START_LOADER = "UPCOMING_NFO_START_LOADER";
export const UPCOMING_NFO_STOP_LOADER = "UPCOMING_NFO_STOP_LOADER";
